var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"\n    Validering\n  "),React.createElement("path",{"d":"M19.1 2.73c-2.88 0-6.25-1-8.6-2.58-.3-.2-.7-.2-1 0C7.15 1.72 3.78 2.73.9 2.73c-.5 0-.9.4-.9.9 0 7.62 3.6 13.7 9.64 16.3.12.05.24.07.36.07s.24-.02.36-.07C16.4 17.33 20 11.25 20 3.63c0-.5-.4-.9-.9-.9z","key":1}),React.createElement("path",{"stroke":"#FFF","fill":"none","strokeWidth":"2.3","d":"M6.15 9l3.02 3.3 5.6-6.15","key":2})]);
}

Shield.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Shield;

Shield.default = Shield;
